import { composeIO } from 'react-compose-io'
import { tabelaEditavelIO } from './TabelaEditavel.IO'
import { TabelaEditavelView } from './TabelaEditavel.View'

export const TabelaEditavel = composeIO(TabelaEditavelView, tabelaEditavelIO)
